"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pollForElement = exports.listenForAttributeChange = exports.getRootElement = exports.getElementByID = void 0;
const utils_1 = require("../utils");
function ssrNoDocument() {
    (0, utils_1.CORE_WARNING)('Document or Window not available, so cannot query DOM.');
    return null;
}
const documentExists = () => undefined !== document;
const windowExists = () => undefined !== window;
/**
 * Finds an element by ID.
 * @param id
 */
function getElementByID(id) {
    if (documentExists()) {
        return document.querySelector(`#${id}`);
    }
    return ssrNoDocument();
}
exports.getElementByID = getElementByID;
/**
 * Finds the uppermost element matching the given selector.
 * @param selector
 */
function getRootElement(selector) {
    if (documentExists() && windowExists()) {
        let el = document.querySelector(selector);
        let win = window;
        while (!el && win !== win.parent) {
            win = win.parent;
            el = win === null || win === void 0 ? void 0 : win.document.querySelector(selector);
        }
        return el;
    }
    return ssrNoDocument();
}
exports.getRootElement = getRootElement;
/**
 * Creates a MutationObserver on a given element and listens for changes to
 * a particular attribute. When it changes, executes the callback.
 * @param targetElement
 * @param attribute
 * @param callback
 * @param emitInitialValue
 */
function listenForAttributeChange(targetElement, attribute, callback, emitInitialValue = true) {
    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' &&
                mutation.attributeName === attribute) {
                const currentValue = targetElement.getAttribute(attribute);
                callback(currentValue);
            }
        }
    });
    observer.observe(targetElement, { attributes: true });
    if (emitInitialValue) {
        const initialValue = targetElement.getAttribute(attribute);
        callback(initialValue);
    }
}
exports.listenForAttributeChange = listenForAttributeChange;
function pollForElement(getElement, interval, maxAttempts) {
    return new Promise((resolve, reject) => {
        let attempts = 0;
        const intervalId = setInterval(() => {
            const element = getElement();
            if (element) {
                clearInterval(intervalId);
                resolve(element);
            }
            else {
                attempts++;
                if (attempts >= maxAttempts) {
                    clearInterval(intervalId);
                    reject(new Error(`Element not found after ${maxAttempts} attempts`));
                }
            }
        }, interval);
    });
}
exports.pollForElement = pollForElement;
